import { render } from "./EventForm.vue?vue&type=template&id=3ad186a7"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"

import "./EventForm.vue?vue&type=style&index=0&id=3ad186a7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__